import React from 'react';
import ReactApexChart from 'react-apexcharts';

// const SemiPieChart = () => {
//     const chartData = {
//       series: [44, 55],
//       options: {
//         chart: {
//           type: 'donut',
//         },
//         colors: ['#008FFB', '#00E396'], // Define custom colors here
//         plotOptions: {
//           pie: {
//             startAngle: -90,
//             endAngle: 90,
//             donut: {
//               labels: {
//                 show: true,
//                 total: {
//                   show: true,
//                   label: 'Total',
//                   formatter: function (w) {
//                     return w.globals.seriesTotals[0];
//                   },
//                 },
//               },
//             },
//           },
//         },
//         labels: ['Male', 'Female'],
//         legend: {
//           position: 'bottom',
//         },
//         responsive: [
//           {
//             breakpoint: 480,
//             options: {
//               chart: {
//                 width: 200,
//               },
//               legend: {
//                 position: 'bottom',
//               },
//             },
//           },
//         ],
//       },
//     };
  
//     return (
//       <div className="pie-chart">
//         <ReactApexChart
//           options={chartData.options}
//           series={chartData.series}
//           type="donut"
//         />
//       </div>
//     );
//   };

// const SemiPieChart = () => {
//   const chartData = {
//     series: [{
//       name: 'Spend',
//       data: [50, 50]}],
//     options: {
//       chart: {
//         type: 'donut',
//       },
//       colors: ['#303778', '#84ADFF'],
//       plotOptions: {
//         pie: {
//           startAngle: -90,
//           endAngle: 90,
//           donut: {
//             labels: {
//               show: false, // Hide the labels
//             },
//           },
//         },
//       },
//       legend: {
//         show: false, // Hide the legend
//       },
//       title: {
//         text: 'Spend',
//         align: 'center',
//         margin: 15,
//         style: {
//           fontSize: '20px', // Custom font size
//           color: '#333',   // Custom text color
//         },
//       },
//       responsive: [
//         {
//           breakpoint: 480,
//           options: {
//             chart: {
//               width: 200,
//             },
//           },
//         },
//       ],
//     },
//   };

//   return (
//     <div className="pie-chart">
//       <ReactApexChart
//         options={chartData.options}
//         series={chartData.series}
//         type="donut"
//       />
//       <div className='pie-title margin-auto'>
//         <h2>Spending</h2>
//         <h2>Wallet</h2>
//       </div>
//     </div>
//   );
// };



  
// export default SemiPieChart;
  

// import React from 'react';
// import ReactApexChart from 'react-apexcharts';

const SemiPieChart = ({money, points}) => {
  const chartData = {
    series: [money, points],
    options: {
      chart: {
        type: 'donut',
        height: 300,
      },
      colors: ['#303778', '#84ADFF'],
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 90,
          donut: {
            labels: {
              // show: false, // Hide the labels
              show: true,
              total: {
                show: true,
                label: "John's Chart", //Your custom chart name here
                fontSize: '20px',
                color: '#000',
                formatter: () => '',
              },
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
      },
      legend: {
        show: false, // Hide the legend
      },
      title: {
        text: '',
        align: 'center',
        margin: 15,
        style: {
          fontSize: '20px', // Custom font size
          color: '#333',   // Custom text color
        },
      },
      labels: [
        'Money', 'Points'
      ],
      // responsive: [
      //   {
      //     breakpoint: 480,
      //     options: {
      //       chart: {
      //         width: 200,
      //       },
      //     },
      //   },
      // ],
      // tooltip: {
      //   enabled: true,
      //   y: {
      //     formatter: function (value) {
      //       return "Spend: " + value;
      //     }
      //   }
      // }
    },
  };

  return (
    <div className="pie-chart">
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="donut"
      />
      <div className='pie-title margin-auto'>
        <h2>Balance</h2>
        <h2>Ratio</h2>
      </div>
    </div>
  );
};

export default SemiPieChart;
